import axios from "axios";
import { APIAddress } from "constants/config";
import Joi from 'joi-browser';


export const schema = Joi.object().keys({
  "content": Joi.string().required(),
});

export default function addContactNotes(contactId, params) {

  if(!contactId){
    return new Promise((resolve, reject) => {
      reject({
        error: new Error('Missing contactId Id')
      })
    })
  }

  let validateResult = Joi.validate(params, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/contact_notes_list/${contactId}/`,
    'method': 'POST',
    'data': JSON.stringify(params),
    'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/contactTimeline/addContactNotes.js